import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import CommonDropdown from 'components/Elements/CommonDropdown';
import PrintIcon from 'assets/printer.svg';
import { useReport } from '../ReportContext';
import { useFilters } from 'components/Elements/Filters/FilterContext';
import { ReportGenerationDialog } from 'components/Modules/ReportSubscriptions';
import { toApiReportType } from 'services/reportSubscriptions';
import { useReportFilterContext } from 'components/Modules/ReportSubscriptions/hooks/useReportFilterContext';

export const ReportHeader = () => {
	const { t } = useTranslation();
	const { config } = useReport();
	const { buildUrlParams, siteAppId } = useFilters();
	const getReportFilterContext = useReportFilterContext();
	const [activeReportRequest, setActiveReportRequest] = useState(null);
	const closeReportDialog = () => setActiveReportRequest(null);

	if (!config.csvExport?.enabled) {
		return null;
	}

	const reports = [
		{
			id: '1',
			name: config.csvExport.label || t("label.cmDataExport"),
			reportType: 'CM_DATA_EXPORT',
		},
	];

	const downloadReportHandler = (reportToBeDownloaded, handleClose) => {
		if (Object.keys(reportToBeDownloaded)?.length < 1) return;
		handleClose();

		const filterParams = buildUrlParams();
		const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		const questionIds = config.csvExport.getQuestionIds?.(filterParams);
		const reportFilterContext = getReportFilterContext();

		setActiveReportRequest({
			reportName: reportToBeDownloaded.name,
			body: {
				reportType: toApiReportType('cmDataExport'),
				filterContext: {
					...reportFilterContext,
					siteAppId,
					timeZone,
					modelVersionTaskQuestionIds: questionIds,
					modelIds:
						reportFilterContext.modelIds && reportFilterContext.modelIds.length > 0
							? reportFilterContext.modelIds
							: filterParams.modelId ? [filterParams.modelId] : [],
				},
				name: null,
				recipientEmail: null,
				sendEmail: false,
			},
		});
	};

	return (
		<>
			<CommonDropdown
				iconSrc={PrintIcon}
				isDownloading={false}
				dataSource={reports}
				dynamicAction={downloadReportHandler}
			/>
			{activeReportRequest ? (
				<ReportGenerationDialog
					open
					onClose={closeReportDialog}
					reportName={activeReportRequest.reportName}
					body={activeReportRequest.body}
				/>
			) : null}
		</>
	);
};
